module.exports = __webpack_public_path__ + "static/media/03_07_03.9c16554c.png";